/***
 * 路由
 * @type {{path: string, component: {name}}}
 */

import { getLocalLotteryType } from "../utils/localStorageService";
import objectPath from "object-path";

// 获取缓存中，第一个路由地址
export const first_redirect = () => {
  const lotteryData = getLocalLotteryType();
  const default_url = "/home/lh?lottery_type=18&category_id=4";
  // 获取path，要么就取默认值
  const firstData = objectPath.get(lotteryData, "0.path") || default_url;
  return firstData;
};

export const route = {
  redirect: first_redirect()
};

/***
 * 进入路由前的操作
 */
export const tasks = [];


// WEBPACK FOOTER //
// ./src/pages/index.js